(function () {
    'use strict';

    angular
        .module('app')
        .controller('registrationsController', ['accountsService', 'registerService', registrationsController]);


    function registrationsController(accountsService, registerService) {
        /* jshint validthis:true */
        var vm = this;
        vm.model = {};

        vm.waiting = false;
        vm.filterApplied = false;

        activate();

        vm.getRegistrations = getRegistrations;
        vm.clearFilter = clearFilter;
        vm.pageChanged = pageChanged;
        vm.filterRegistrations = filterRegistrations;

        function activate() {
           
            vm.model = accountsService.getAuthenticatedAccount()
                .then(function(response) {
                    vm.model.isAdmin = (response.accountType === AccountType.Admin ||
                        response.accountType === AccountType.SuperAdmin);
                    vm.model.isCompanyAdmin = response.accountType === AccountType.Company;
                    vm.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                    vm.model.authenticatedAccountId = response.accountId;
                });

            clearFilter();
           
        }

        function filterRegistrations() {
            vm.filterApplied = true;
            vm.filter.page = 1;
            pageChanged();
        }

        function getRegistrations(name, page, take) {
            vm.waiting = true;

            registerService.getRegistrations(name, page, take)
                .then(function(response) {
                    vm.registrations = response;
                });

            vm.waiting = false;
        }

        function pageChanged() {
            getRegistrations(vm.filter.name, vm.filter.page, vm.filter.take);
        }

        function clearFilter() {
            vm.filter = {
                name: '',
                page: 1,
                take: 20
            };
            vm.filterApplied = false;
            pageChanged();
        }

    }
})();
